module.exports = ".alert-text {\n  font-size: 14px;\n  color: #808080;\n  margin-top: 24px; }\n\n.has-error {\n  border: 1.5px solid #FF1744;\n  padding: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/imagens-tratamento/imagens-tratamento.component.scss
// module id = ./src/app/components/imagens-tratamento/imagens-tratamento.component.scss
// module chunks = main